module.exports = __webpack_public_path__ + "img/successful-email-verification.46c89272.svg";